import React from 'react'
import App, {Container} from 'next/app'

class Layout extends React.Component {
  render () {
    const {children, title} = this.props
    return <div className='layout'>
      {children}
    </div>
  }
}

export default class MyApp extends App {
  static async getInitialProps({ Component, router, ctx }) {
    let pageProps = {}

    if (Component.getInitialProps) {
      pageProps = await Component.getInitialProps(ctx)
    }

    return { pageProps }
  }
  render () {
    const {Component, pageProps} = this.props
    return <Container>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </Container>
  }
}


// WEBPACK FOOTER //
// pages/_app.js